import {HookMatchCriteria, HookRegOptions, TransitionHookFn} from '@uirouter/react'
import {
  JobType,
  JobStatus,
  LegionJobSortInput,
  DatabaseMetadataSortInput,
  QueryJobCountByTypeArgs,
  QueryJobCountByUrlArgs,
  QueryJobStatusCountArgs,
  JobRequestSortInput,
} from 'graphql-api'
import {PaginationState, SortingState} from '@tanstack/react-table'
import {FiltersType as DatabasesFiltersType} from 'redux/databases/state'
import {FiltersType as JobsFiltersType} from 'redux/jobs/state'
import {Action, ThunkAction} from '@reduxjs/toolkit'
import {AppState} from 'redux/config'

export type CursorType = string | null | undefined

export type JobOrderType = LegionJobSortInput | null | undefined

export type DatabaseOrderType = DatabaseMetadataSortInput | null | undefined

export type JobRequestOrderType = JobRequestSortInput | null | undefined

export type GraphQLPaginationType = {
  first: number | null,
  after: CursorType,
  last: number | null,
  before: CursorType,
}

export enum PaginationDirection {
  PREV = 'previous',
  NEXT = 'next'
}

export enum Status {
  IDLE = 'IDLE',
  PENDING = 'PENDING',
  OK = 'OK',
  REJECTED = 'REJECTED'
}

export type TransitionHookType = {
  criteria: HookMatchCriteria,
  callback: TransitionHookFn,
  options?: HookRegOptions,
}

export type JobTypeType = typeof JobType[keyof typeof JobType]
export type JobStatusType = typeof JobStatus[keyof typeof JobStatus]

export type CommonFiltersType = JobsFiltersType | DatabasesFiltersType | undefined

export type GridStateParamsType = {
  pagination: PaginationState,
  sorting: SortingState,
  filters: CommonFiltersType,
}

export type EmptyColumnDefType = {
  '': string
}

export type ThunkType = (...args: any[]) => ThunkAction<void, AppState, unknown, Action<string>>

export type FilterTypeType = JobTypeType | JobStatusType | string

export type FilterOptionType = {
  value: string,
  label: string,
  subLabel?: string,
}

export enum UrlSelection {
  ONE = 'One',
  MULTIPLE = 'Specify Urls',
  ALL = 'All',
  EMPTY = 'Empty'  
}

export type HomeStatsArgsType = QueryJobCountByTypeArgs | QueryJobCountByUrlArgs | QueryJobStatusCountArgs
